__webpack_require__.p = "/Stratml-Editor/";